const callbacks = {};

function fire(eventName, event) {
    // eventName !== "updatefpsdisplay" && eventName !== "post_render" && console.log(eventName);
    if (callbacks[eventName]) {
        callbacks[eventName].forEach(f => { f(event); });
    }
}

function listen(eventName, callback) {
    callbacks[eventName] = callbacks[eventName] || [];
    callbacks[eventName].push(callback);
}

function unlisten(eventName, callback) {
    const eventCallbacks = callbacks[eventName];

    if (eventCallbacks) {
        let index = eventCallbacks.indexOf(callback);

        if (index > -1) { eventCallbacks.splice(index, 1); }
    }
}

function count() {  // just for debugging
    let i = 0;
    Object.keys(callbacks).forEach(name => {
        i+=callbacks[name].length
    });
    return i
}

export { callbacks, fire, listen, unlisten, count };